import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const resolveUrl = (u) => (u && u.startsWith('/') ? `${BACKEND_URL}${u}` : u);

const ThemeBackground = ({ onTheme }) => {
  const [theme, setTheme] = useState(null);
  const [portrait, setPortrait] = useState(
    typeof window !== 'undefined' ? window.matchMedia('(orientation: portrait)').matches : false
  );

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/themes/active`)
      .then((res) => {
        const t = res.data && res.data.id ? res.data : null;
        setTheme(t);
        if (onTheme) onTheme(t);
      })
      .catch(() => {});
    const mq = window.matchMedia('(orientation: portrait)');
    const handler = (e) => setPortrait(e.matches);
    mq.addEventListener ? mq.addEventListener('change', handler) : mq.addListener(handler);
    return () => {
      mq.removeEventListener ? mq.removeEventListener('change', handler) : mq.removeListener(handler);
    };
  }, []);

  if (!theme) return null;
  const src = portrait
    ? resolveUrl(theme.video_vertical_url || theme.video_horizontal_url)
    : resolveUrl(theme.video_horizontal_url || theme.video_vertical_url);
  if (!src) return null;

  const overlay = Math.max(0, Math.min(100, theme.overlay_opacity ?? 25));
  const overlayRGB = theme.overlay_mode === 'dark' ? '0,0,0' : '255,255,255';

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none" style={{ zIndex: -1 }}
         data-testid="theme-background">
      <video key={src} src={src} autoPlay muted loop playsInline
             className="w-full h-full object-cover" />
      {overlay > 0 && (
        <div className="absolute inset-0" style={{ backgroundColor: `rgba(${overlayRGB},${overlay / 100})` }} />
      )}
    </div>
  );
};

export default ThemeBackground;
